"use client";
import React, { useEffect } from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import RouterMgr from "@/Core/RouterMgr";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {VisitorRechargeDialogFC} from "@/app/(shop)/UI/VisitorRechargeDialog/VisitorRechargeDialog";
import {PaySelectionDialogFC} from "@/app/(pay)/UI/PaySelectionDialog/PaySelectionDialogFC";
import AuthTrack from "@/Core/AuthTrack";

export interface ForcedLoginDialogProps extends SDialogProps {}

//强制登陆弹窗
export const ForcedLoginDialogFC: React.FC<ForcedLoginDialogProps> = (props) => {
    const { fcKey, onClose, isCloseBtn } = props;
    const {closeDialog} = useDialogMethods(fcKey);

    const onCloseCall = () => {
        // 关闭支付方式弹窗
        if (SDialogManagerFC.getFCKey(PaySelectionDialogFC)) {
            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(PaySelectionDialogFC))
        }
        // 关闭游客充值弹窗
        if (SDialogManagerFC.getFCKey(VisitorRechargeDialogFC)) {
            SDialogManagerFC.closeDialog(SDialogManagerFC.getFCKey(VisitorRechargeDialogFC))
        }
        onClose?.();
        closeDialog();
    }

    useEffect(() => {
        AuthTrack.showRegistered()
        return () => {};
    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            isCloseBtn={isCloseBtn}
            isClickMaskClose={false}
            buttons={[
                {
                    label: "Go to Login",
                    onClick: () => {
                        AuthTrack.clickGoToLogin()
                        onCloseCall();
                        RouterMgr.login();
                    },
                    style: "blueBtn",
                },
            ]}
        >
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                }}
            >
                <div>This cell phone number has already been registered and cannot be re-registered</div>
            </div>
        </SDialogFC>
    );
};
